module.exports = __webpack_public_path__ + "img/22.1012b1a3.png";